module.exports = __webpack_public_path__ + "img/smoke-detector-sm.7f1163ac.svg";